<template>
  <div class="send-edit-box">
    <user-header></user-header>
    <user-menu :status='1'></user-menu>
    <div class="send-edit-main-box">

      <h3 class="item-box-title">お届け先住所の選択</h3>

      <div class="send-box">
        <input id="st_1" type="radio" v-model.number="send_type" value="1">
        <label for="st_1">登録されている住所にお届け</label>
        <div class="address-box">
          {{record_address.name}}<br />
          〒{{record_address.zip_code}}
          {{record_address.prefecture}}<br />
          {{record_address.address1}}
          {{record_address.address2}}
        </div>
      </div>

      <div class="send-box">
        <input id="st_2" type="radio" v-model.number="send_type" value="2">
        <label for="st_2">新しい住所にお届け</label>
        <div class="address-box" v-if="send_type == 2">
          <dl>
            <dt class="c-bg-deep">お名前(宛名)<span class="red">(必須)</span></dt>
            <dd><input type="text" class="add-text" v-model="new_address.name"></dd>
          </dl>
          <dl>
            <dt class="c-bg-deep">郵便番号</dt>
            <dd>
              <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="3" v-model="zip_codes[0]"><span>-</span>
              <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="zip_codes[1]">
            </dd>
          </dl>
          <dl>
            <dt class="c-bg-deep">都道府県</dt>
            <dd>
              <select v-model="new_address.prefecture">
                <option v-for="(item, index) in prefectures_list" :key="index" :value="item.name">{{item.name}}</option>
              </select>
            </dd>
          </dl>
          <dl>
            <dt class="c-bg-deep">住所１<span class="caption">(市区町村名)</span></dt>
            <dd><input type="text" class="add-text long" placeholder="市区町村名" v-model="new_address.address1"></dd>
          </dl>
          <dl>
            <dt class="c-bg-deep">住所２<span class="caption">(番地・マンション名)</span></dt>
            <dd><input type="text" class="add-text long" placeholder="番地・マンション名" v-model="new_address.address2"></dd>
          </dl>

        </div>
      </div>

      <div class="send-box">
        <input id="st_3" type="radio" v-model.number="send_type" value="3">
        <label for="st_3">過去のお届け先から選択(直近の５件から選択)</label>
        <div class="address-box" v-if="send_type == 3">
          <div class="address-list" v-for="(item, index) in address_history" :key="index">
            <input :id="`sh_${index}`" type="radio" v-model.number="history_id" :value="index">
            <label :for="`sh_${index}`">
              {{(item.name)}}<br />
              <span class="address">〒{{item.zip_code}}
              {{item.prefecture}}</span><br />
              <span class="address">{{item.address1}}
              {{item.address2}}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="btn-box">
        <button class="button back" @click="back()">戻る</button>
        <button class="button buy" @click="buy()">次へ<span class="caption">(ご注文内容の最終確認)</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'SendEdit',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      send_type: this.$store.getters['uCart/send_type'],
      record_address: {},
      new_address: this.$store.getters['uCart/new_address'],
      address_history: [],
      history_id: this.$store.getters['uCart/history_id'],
      zip_codes: [],
      send_address: this.$store.getters['uCart/send_address'],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    prefectures_list () {return this.$DF.PREFECTURES_LIST;},
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    let ld = new this.$loader(this);
    ld._data_set({});
    ld._post_cb_f = this.send_list_cb;
    ld._load_start('/user/send_list.php');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.new_address.zip_code) {
      this.zip_codes = this.new_address.zip_code.split('-');
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    buy () {
      if (this.send_type === 1) {
        this.send_address = this.record_address;
      } else if (this.send_type === 2) {
        if (
          this.$lib._emptyChk(this.zip_codes[0], true) === false ||
          this.$lib._emptyChk(this.zip_codes[1], true) === false
        ) {
          this.$alert('alert', 'お届け先を入力してください。');
          return;
        }
        if (
          this.$lib._emptyChk(this.new_address.prefecture, true) === false ||
          this.$lib._emptyChk(this.new_address.address1, true) === false
        ) {
          this.$alert('alert', 'お届け先を入力してください。');
          return;
        }

        this.send_address = this.new_address;
        this.send_address.zip_code = this.zip_codes.join('-');

        this.$store.commit('uCart/set_new_address', this.new_address);
      } else {
        if (this.history_id === -1) {
          this.$alert('alert', 'お届け先を選択してください。');
          return;
        }
        this.$store.commit('uCart/set_history_id', this.history_id);
        this.send_address = this.address_history[this.history_id];
      }
      this.$store.commit('uCart/set_send_type', this.send_type);
      this.$store.commit('uCart/set_address', this.send_address);
      this.$router.push({name: 'uFinalConfirm', query: {}});
      // window.onCreated_cb_set(this.buy_cb);
      // const tag = this.$lib._$id('payjp_checkout_box');
      // const evt = document.createEvent("MouseEvents");
      // evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      // tag.children[0].dispatchEvent( evt );
    },
    // buy_cb (res) {
    //   if (res.error) {
    //     this.$alert('alert', 'カード情報に謝りがあります。\n再度入力してください。');
    //     return;
    //   }
    //
    //   let ld = new this.$loader(this);
    //   const total = this.$store.getters['uCart/total_price'];
    //   ld._data_set({
    //     'card_token': res.id,
    //     'orders': this.$store.getters['uCart/carts'],
    //     'post_price': total[2],
    //     'tax': total[1],
    //     'send_address': this.send_address,
    //   });
    //   ld._post_cb_f = this.pay_check_cb;
    //   ld._load_start('/user/pay_check.php');
    // },
    // pay_check_cb (data) {
    //   // カートをリセット
    //   this.$store.commit('uCart/reset');
    //
    //   this.$router.push({name: 'uPayFin', query: {'order_id': data.data.order_id}});
    // },
    send_list_cb (data) {
      if (data.res === 1) {
        this.record_address = data.data.record_address;
        this.address_history = data.data.address_history;

      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    back () {
      this.$router.push({name: 'uMain', query: {}});
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.send-edit-box {
  .send-edit-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
    .item-box-title {
      font-size: 22px;
      text-align: center;
      border-bottom: 4px solid #d4ff9d;
      padding: 0px 10px;
      margin: 0;
    }
    .send-box {
      width: 660px;
      margin: 30px auto 0 auto;
      text-align: left;
      .address-box {
        margin-top: 10px;
        padding: 0 0 0 25px;
      }
    }
    .button {
      margin: 0px 20px 20px 20px;
      padding: 13px 10px 15px 10px;
      width: 36%;
      border: none;
      border-radius: 6px;
      color: #fefefe;
      font-size: 16px;
      cursor: pointer;
    }
    .address-list {
      margin-top: 10px;
      .address {
        display: inline-block;
        padding: 0 0 0 25px;
      }
    }
    .btn-box {
      margin-top: 50px;
      .back {
        width: 100px;
      }
    }
    dl {
      display: flex;
      background-color: #fcf3f3;
      border-top: 1px solid #fefefe;
      border-left: 1px solid #fefefe;
      border-right: 1px solid #fefefe;
    }
    dt {
      text-align: left;
      width: 330px;
      color: #5c5945;
      padding: 14px;
      background: #fee2e2;
      border-right: 4px solid #df274c;
    }
    dl:last-child {
      border-bottom: 1px solid #fefefe;
    }
    dd {
      text-align: left;
      font-weight: bold;
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      span {
        padding: 0 5px;
      }
      input {
        height: 32px;
        font-size: 18px;
      }
      select {
        width: 100px;
        height: 32px;
      }
    }
    .small {
      width: 60px;
      min-width: 60px;
    }
    .caption {
      font-size: 12px;
    }
  }
  @media (max-width: 767px) {
    .send-edit-main-box {
      padding: 20px;
      margin: 50px 0 0 0;
      height: calc(100vh - 90px);
      .send-box {
        width: 100%;
      }
      dl {
        display: block;
      }
      dt {
        width: auto;
        border-right: 0px;
        border-bottom: 1px solid #dddddd;
      }
      .button {
        width: 50%;
        margin: 0px 10px 20px 10px;
      }
    }
  }
}
</style>
